import { useEffect } from 'react'

export type UseLogoutWhenSignedOutProps = {
  loading: boolean
  isAuthenticated: boolean
  logout: () => void
}

/**
 * A private layout's exit: once the viewer has resolved and is not authenticated, call `logout` once.
 * It runs in an effect because a layout's first render has no live navigate yet — react-router's
 * `useNavigate` ignores a call made while rendering (`node_modules/react-router/dist/index.js:228`).
 */
export const useLogoutWhenSignedOut = ({ loading, isAuthenticated, logout }: UseLogoutWhenSignedOutProps): void => {
  useEffect(() => {
    if (!loading && !isAuthenticated) logout()
    // keyed on the verdict alone — `logout` is a new closure every render and its mutation re-renders the
    // layout, so listing it would re-fire the logout on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isAuthenticated])
}
